import { JobReadinessCheckDto } from './JobReadinessCheckDto';
import { JobReadinessStatus } from './JobReadinessStatus';

/**
 * Overall job-readiness pre-flight result for one job (WI 30856): the aggregate
 * traffic-light plus the per-check breakdown that drives the readiness dialog.
 */
export interface JobReadinessDto {
  VPJobID: string;
  OverallStatus: JobReadinessStatus;
  Checks: JobReadinessCheckDto[];
}
